/**
 * The Monitored capability's two librarian-authored texts on an
 * ObservationDefinition: `_monitoredEventPrompt` (OMON-174) and
 * `_monitoredEventGuidance` (Zammad #49088).
 *
 * Ed, 2026-09-24: each is written only when it actually changed, so saving an
 * untouched event never stamps empty fields onto it. Absent on the stored doc
 * counts as "" — the editor seeds absent as "", so an untouched absent field
 * is not a change. The caller applies the Monitored-capability gate.
 */

import { eventGuidanceText } from "../guidance/single-text";

export type MonitoredTextWrites = {
  _monitoredEventPrompt?: string;
  _monitoredEventGuidance?: string;
};

export function changedMonitoredTextFields(
  editing: { monitoredEventPrompt: string; monitoredEventGuidance: string },
  stored: { _monitoredEventPrompt?: unknown; _monitoredEventGuidance?: unknown },
): MonitoredTextWrites {
  const was = (v: unknown) => (typeof v === "string" ? v : "");
  const writes: MonitoredTextWrites = {};
  if (editing.monitoredEventPrompt !== was(stored._monitoredEventPrompt)) {
    writes._monitoredEventPrompt = editing.monitoredEventPrompt;
  }
  // The editor seeds guidance in the one-text rules (legacy `##` sections read
  // as `#` folds, Ed 2026-09-29), so "untouched" is judged against that same
  // reading — opening a legacy event never rewrites it.
  if (editing.monitoredEventGuidance !== eventGuidanceText(stored._monitoredEventGuidance)) {
    writes._monitoredEventGuidance = editing.monitoredEventGuidance;
  }
  return writes;
}
